


















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { VueDropDown } from "@/models/accounting/customerinfo";
import {
  MessageCreateViewModel,
  MessagesViewModel,
} from "@/models/telephony/message";
import { getSendMessageHeaders } from "@/views/fixedOps/repairorder/repair.order";
import {
  Attachment,
} from "@/models/accounting/customerinfo";
import {
  ConversationTypes,
  MetadataType,
  MetadataKeyIdentifier,
  TemplateAssociationType,
} from "@/enums/enums";
import { Base } from "@/components/common/base";
import {
  messageService,
  templateService,
  jobRequisitionService,
} from "@/shared";
import { VHeaders, PaginationModel } from "@/models/pagedlistmodel";
import { FileUploadDataViewModel } from "@/Alynk.dtos";
import { IFileUploaderOption } from "@/models/fileUploader";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    isValidate() {
      return this.messageToSend.to && this.messageToSend.body;
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue'),
  },
})
 class SendMessage extends Base {
  public images = [
    ".ani",
    ".bmp",
    ".cal",
    ".fax",
    ".gif",
    ".img",
    ".jpg",
    ".jpe",
    ".jpeg",
    ".jpg",
    ".mac",
    ".pbm",
    ".pcd",
    ".pcx",
    ".pct",
    ".pgm",
    ".png",
    ".ppm",
    ".psd",
    ".ras",
    ".tga",
    ".tif",
    ".tiff",
    ".wmf",
    "image/ani",
    "image/bmp",
    "image/cal",
    "image/fax",
    "image/gif",
    "image/img",
    "image/jpeg",
    "image/mac",
    "image/pbm",
    "image/pcd",
    "image/pcx",
    "image/png",
    "image/tga",
    "image/tiff",
    "image/wmf",
    "image/ppm",
    "image/ppm",
    "image/psd",
    "image/ras",
  ];
  public allowedFiles = this.images.concat([
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".xls",
    ".xlsx",
  ]);

  public templateloading: boolean = false;
  public bodyloading: boolean = false;
  public customerloading: boolean = false;
  public selectedTemplate: string = "";
  public selectedCustomerNumber: string = "";
  public showAttachmentDialog: boolean = false;
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = "";
  public dragging: boolean = false;
  public disableSubmitButton: boolean = false;
  public fileRef: any;
  public phoneNumber: string = "";
  public gridloading: boolean = false;
  public unreadMessageCount: string = "";
  public constants: any = {
    customerKey: "",
    recordKey: "",
    vin: "",
    candidateName: "",
    phoneNumber: "",
    unreadMessageCount: "",
  };
  public headers: VHeaders[] = getSendMessageHeaders(this);
  public pagination = new PaginationModel("name");
  public pagedTextLog: any[] = [];
  public fileUploderRef: string = "requisitionMessageRef";
  public uploadBtnLoading: boolean = false;
  public attachmentFiles: FileUploadDataViewModel[] = [];
  public attachments: Attachment[] = [];
  public customerNumberItems: VueDropDown[] = [];
  public templateItems: any[] = [];
  public customerInfo: any;
  public actions = [
    {
      type: "button",
      icon: "far fa-folder-open",
      title: this.$parent.$t(
        "sendMessage.rOSendMessageGrid.gridActions.showFolder"
      ) as string,
      disable: (model: MessagesViewModel) => {
        return (
          model.attachments != null &&
          model.attachments &&
          model.attachments.length === 0
        );
      },
      action: (model: MessagesViewModel) => {
        // this.openAttachmentPopup(model);
      },
    },
  ];
  public bodyRules: any = {
    required: (value) =>
      !!value ||
      (this.$parent.$t("sendMessage.validationBodyRequired") as string),
  };

  // tslint:disable-next-line:max-line-length
  public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );

  constructor() {
    super();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "backTolist") {
      this.backToList();
    } else if (methodName === "sendMessage") {
      if (!this.messageToSend.to || !this.messageToSend.body) {
        this.showAlert(false, this.$t("sendMessage.validationFormIsInvalid"));
        this.resetMethodName(methodName);
        return;
      }
      this.sendMessage();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "0",
      type: "button",
      title: this.$t("sendMessage.btnBackToList"),
      disabled: false,
      visible: true,
      class: "btn",
      label: this.$t("sendMessage.btnBackToList"),
      click: "backTolist",
      icon: "fas fa-arrow-left",
    });
    this.$emit("updateToolBar", buttons);
  }
  public mounted() {
    this.$root.$emit("sidebar.layout.vue", "requisition");

    this.messageToSend.recordIdentifier = this.$route.params.type;

    // Toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    // SHOULD BIND CUSTOMER KEY, RECORD KEY
    Object.keys(this.constants).forEach((key) => {
      if (this.$route.query[key]) {
        this.constants[key] = (this.$route.query[key] || "").toString().trim();
      }
    });

    // this.messageToSend.to = this.constants.phoneNumber;
    this.messageToSend.recordKey = this.constants.recordKey;
    this.messageToSend.customerName = this.constants.candidateName;
    this.messageToSend.vin = this.constants.vin;
    this.unreadMessageCount = this.constants.unreadMessageCount;

    this.messageToSend.recordKeyIdentifier = MetadataKeyIdentifier[MetadataKeyIdentifier.Id];

    this.getTemplates();

    this.customerNumberItems = [
      { name: this.constants.phoneNumber, value: this.constants.phoneNumber },
    ];

    if (Number(this.unreadMessageCount) > 0) {
      this.MessageAsRead(this.messageToSend.recordKey);
    }
    this.getExistingMessages();

  }

  public async getTemplates(): Promise<void> {
    try {
      this.templateloading = true;
      const templates = await templateService.getStoreTemplates(TemplateAssociationType.Recruiting);
      this.templateItems = templates.results;
    } catch (e) {
      console.log(e);
    } finally {
      this.templateloading = false;
    }
  }

  public async getTemplateDescription(selectedTemplateId): Promise<void> {
    this.bodyloading = true;
    if (selectedTemplateId == null || selectedTemplateId === "") {
      this.showAlert(false, this.$t("sendMessage.validationInvalidtemplate"));
      return;
    }
    try {
      const template = await templateService.getTemplateDescription(
        selectedTemplateId,
        this.messageToSend.customerName,
        this.messageToSend.vin,
        this.messageToSend.appointmentDateTime,
        this.messageToSend.appointmentNumber,
        "",
        "",
        this.messageToSend.customerKey,
        this.messageToSend.recordKey
      );
      this.messageToSend.body = template.text;
    } finally {
      this.bodyloading = false;
    }
  }

  public openAttachmentDialog(id: string): void {
    this.showAttachmentDialog = true;
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: "recruitment.jobrequisition" });
    }
  }

  public async sendMessage(): Promise<void> {
    if (this.validateForm()) {
      if (
        this.messageToSend.to == null ||
        this.messageToSend.to === "" ||
        !this.messageToSend.body
      ) {
        this.showAlert(
          false,
          this.$t("sendMessage.alertCustomerNumberFieldEmptyRequired")
        );
        return;
      }
      try {
        this.disableSubmitButton = true;
        this.$emit("update:progress", this.disableSubmitButton);
        this.messageToSend.files = this.attachmentFiles;
        await jobRequisitionService.sendMessage(this.messageToSend);
        this.messageToSend.body = "";
        this.showAlert(true, this.$t("sendMessage.messageSentSuccessfully"));
        this.messageToSend.files = [];
        this.selectedFiles = [];
        if (this.fileRef && this.fileRef.clear) {
          this.fileRef.clear();
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
        this.attachmentFiles = [];
        this.files = [];
        this.$root.$emit('resetFileList', this.fileUploderRef);
        this.getExistingMessages();
      }
    }
  }

  public async getExistingMessages(): Promise<void> {
    // if (this.constants.customerKey && this.messageToSend.recordIdentifier) {
    try {
      this.gridloading = true;
      const response = await messageService.getExistingMessages(
        "",
        this.constants.recordKey,
        MetadataType.JobRequisitions.toString()
      );

      this.pagedTextLog = response.existingMessages.results;
      this.pagination.totalItems = response.existingMessages.results.length;
    } finally {
      this.gridloading = false;
    }
    // }
  }

  public updatePaging(paging): void {
    this.pagination = paging;
  }

  public async MessageAsRead(recordKey: string): Promise<void> {
    try {
      await jobRequisitionService.markMessageAsRead(recordKey);
    } finally {
    }
  }

  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
    extensions: this.allowedFiles
  };
  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }

}
export default SendMessage;
